import { styled } from "@mui/material";

export const PlanFileLinkStyled = styled('div')({
  span: {
    textTransform: 'none',
  },
});